var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXCircle = function SvgXCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.5a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16M7.469 7.47a.747.747 0 0 0 0 1.058l1.468 1.47-1.468 1.468a.75.75 0 0 0 1.06 1.06l1.468-1.47 1.469 1.47a.75.75 0 0 0 1.06-1.06l-1.47-1.469 1.469-1.469a.75.75 0 0 0-1.06-1.06L9.998 8.94 8.528 7.469a.747.747 0 0 0-1.06 0"
  })));
};
export default SvgXCircle;